/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BrandDetailsPageContext } from "@insite/content-library/Pages/BrandDetailsPage";
import { Button } from "@insite/mobius/index";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { FC, useContext } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    marginRight = "marginRight",
    marginLeft = "marginLeft",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.marginRight]: boolean;
        [fields.marginLeft]: boolean;
    };
}

type Props = OwnProps & HasHistory;

const VisitWebsiteButton: FC<Props> = ({ history, fields }) => {
    const { value: brand } = useContext(BrandStateContext);

    if (!brand) {
        return null;
    }

    const handleButtonClick = (e: any, url: string) => {
        e.preventDefault;
        history.push(url);
    };

    if (!brand.externalUrl) {
        return null;
    }

    return (
        <Button
            data-test-selector="brandExternalUrlLink"
            onClick={(e: any) => {
                handleButtonClick(e, brand.externalUrl);
            }}
            css={css`
                margin-right: ${fields.marginRight ? "15px" : "0"};
                margin-left: ${fields.marginLeft ? "15px" : "0"};
            `}
        >
            {translate("Visit {0} Website").replace("{0}", brand.name)}
        </Button>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(withHistory(VisitWebsiteButton)),
    definition: {
        group: "Brand Details",
        displayName: "Visit Website Button",
        allowedContexts: [BrandDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.marginLeft,
                displayName: "Margin Left",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                isRequired: false,
            },
            {
                name: fields.marginRight,
                displayName: "Margin Right",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                isRequired: false,
            },
        ],
    },
};

export default widgetModule;
